// @ts-nocheck
import React from "react";
import {
  ShoppingBag,
  RefreshCw,
  Package,
  XCircle,
  CreditCard,
  Store,
} from "lucide-react";
import { cn } from "@/lib/utils";

export const ActivityIcon = ({ icon }) => {
  const map = {
    order: {
      I: ShoppingBag,
      c: "bg-emerald-100 dark:bg-emerald-900 text-emerald-600 dark:text-emerald-400",
    },
    sync: {
      I: RefreshCw,
      c: "bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-400",
    },
    inventory: {
      I: Package,
      c: "bg-amber-100 dark:bg-amber-900 text-amber-600 dark:text-amber-400",
    },
    error: {
      I: XCircle,
      c: "bg-rose-100 dark:bg-rose-900 text-rose-600 dark:text-rose-400",
    },
    plan: {
      I: CreditCard,
      c: "bg-indigo-100 dark:bg-indigo-900 text-indigo-600 dark:text-indigo-400",
    },
    marketplace: {
      I: Store,
      c: "bg-teal-100 dark:bg-teal-900 text-teal-600 dark:text-teal-400",
    },
  };
  const { I, c } = map[icon] || map.sync;
  return (
    <div
      className={cn(
        "w-8 h-8 rounded-full flex items-center justify-center shrink-0",
        c,
      )}
    >
      <I className="w-4 h-4" />
    </div>
  );
};
